import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { AIAssistant } from "@/components/AIAssistant";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-app">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
      <AIAssistant />
    </div>
  );
}
